import type { DiskoType } from "ls/features/files/utils";
import type { RequestOptions } from "../common/server";
import type { IdOrFilesystemId } from "./types";
import type { DiskoEnabledJs, InsertLocation, ResponseObject, ShortcutCloneJs, ShortcutCreateJs, ShortcutType } from "@/generated/models";
import type { VarsJsOf } from "@/services/models/responseObject";
import { EmptyGuid } from "@/common/lib";
import { objectToFormData } from "@/services/utils/formData";
import { server } from "./server";

export type CreateModel = IdOrFilesystemId & { Name?: string; Type: DiskoType; insertLocation?: InsertLocation; insertAfter?: string };

export async function create(model: CreateModel) {
  const formData = objectToFormData(model);
  const response = await server.post("disko/create", { body: formData });
  return await response.json() as ShortcutCreateJs;
}

export async function createNew(Type: ShortcutType) {
  const model = {
    Type,
  };
  const formData = objectToFormData(model);
  const result = await server.post("disko/new", { body: formData });
  return await result.json() as VarsJsOf<{
    shortcut: string;
    name: string;
  }>;
}

export const OnPremSubInstanceGuid = "00de3840-a431-482e-bef4-573e2f1297d6";
export async function enabledForOrganization(options: { organizationId: string }, { signal }: RequestOptions = {}) {
  if (!options.organizationId || options.organizationId === OnPremSubInstanceGuid) {
    return { enabled: false, simsEnabled: false } satisfies DiskoEnabledJs;
  }

  // A9-5533 Ensuring permission check returns true for private workspace in Public Cloud
  if (options.organizationId === EmptyGuid) {
    return { enabled: true, simsEnabled: false } satisfies DiskoEnabledJs;
  }

  const searchParams = {
    organizationId: options.organizationId,
  };
  const response = await server.get("disko/enabledForOrganization", { searchParams, signal });
  return await response.json() as DiskoEnabledJs;
}

export async function checkConvertPermissions({ shortcut }: { shortcut: string }) {
  const formData = objectToFormData({ shortcut });
  const response = await server.post("disko/CheckConvertPermissions", { body: formData });
  return await response.json() as ResponseObject;
}
